
import {
	Component,
	Vue,
	Watch
} from 'vue-property-decorator';
import RadioButton from '@/components/radio-button.vue';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import UploadImg from '@/components/upload-img.vue';
import Switch from '@/components/switch.vue';
import {
	getProviderSalesOrderList
} from '@/api/order';
import {
	downloadFile
} from '@/utils/index';
import {
	logisticsExcel,
	getLogisticsExcelUrl,
	sellOrderDetailImport,
	orderchangeMiniProgramAppSMSShipNoticeState
} from '@/api/logistics';
import {
	getOssToken
} from '@/api/user'
import {
	getSearchDate,
	nextDay
} from "@/utils/index"

@Component({
	name: 'aftersales-order',
	components: {
		RadioButton,
		PageFooter,
		UploadImg,
		PickerDate,
		'slz-dialog': Dialog,
		'slz-switch': Switch
	}
})
export default class AftersalesOrder extends Vue {
	private IsOpenMiniProgramAppSMSShipNotice = false
	private radioType = 0;
	private radioList: any = [{
		label: '未发货',
		value: 0
	}, {
		label: '已发货',
		value: 1
	}]
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private keyword = '';
	private list = [];
	private filterTime: any = [nextDay(getSearchDate(2)[0], -30), getSearchDate(2)[0]].join('/')
	private showImportExel = false;
	private uploadToken: any = {};
	private importUrl = '';
	private showExportOrder = false;
	private exportFilterTime: any = '';
	private currentId: any = 0;
	private exportLoopTime: any = null;
	private excelPwd = '';
	private exportLoading = false;
	private importName = '';
	private importloading = false
	private tableloading = false

	private mounted() {
		if (this.$route.params.time) {
			this.filterTime = this.$route.params.time
		}
		this.getList();
		// this.getToken();
	}

	private async exportabnormal(e) {
		let row = await e
		let url = location.origin + '/provider/order/expressAbnormalOrderDetailExport'
		url += '?ProductId=' + (row.ProductId || '');
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + (dt[0] || '');
			url += '&EndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
		}
		window.open(url);
	}

	private async changeOpen(e) {
		try {
			let res = await orderchangeMiniProgramAppSMSShipNoticeState({})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
			}
		} finally {
			//
		}
	}
	// 获取token
	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.uploadToken = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			console.error('getOssToken ===>', e)
		}
	}

	private doSearch() {
		if (this.filterTime) {
			let time = this.filterTime.split('/')
			// console.log((new Date(time[1]).getTime()-new Date(time[0]).getTime())/1000/60/60/24+1)
			if ((new Date(time[1]).getTime() - new Date(time[0]).getTime()) / 1000 / 60 / 60 / 24 + 1 > 31) {
				this.$message.error('时间跨度请不要超过30天')
				return
			}
		}
		console.log(this.filterTime)
		this.pageNo = 1;
		this.getList();
	}

	private clearSearch() {
		this.pageNo = 1;
		this.keyword = '';
		this.filterTime = [nextDay(getSearchDate(2)[0], -30), getSearchDate(2)[0]].join('/')
		this.getList();
	}

	private changePage(num: number) {
		this.pageNo = num;
		this.getList();
	}

	private async getList() {
		let params: any = {
			SendState: this.radioType,
			Keywords: this.keyword,
			// Skip:(this.pageNo-1)*this.pageSize,
			// Take: this.pageSize,
		}

		if (this.filterTime) {
			let time = this.filterTime.split('/')
			params.StartTime = time[0]
			params.EndTime = nextDay(time[1], 1)
		}
		try {
			this.tableloading = true
			const res: any = await getProviderSalesOrderList(params);
			this.list = [res.Result.Total, ...res.Result.List];
			this.IsOpenMiniProgramAppSMSShipNotice = res.Result.IsOpenMiniProgramAppSMSShipNotice
			// console.log(res.Result)
			// this.total = res.Result.Total
		} catch (err) {
			console.log(err);
		} finally {
			this.tableloading = false
		}
	}

	private toDetail(record: any) {
		console.log(this.radioType)
		let query: any = {
			id: record.ProductId,
			state: this.radioType,
			filterTime: this.filterTime
		}
		this.$router.push({
			name: 'Order_Detail',
			query: query
		})
	}

	private uploadSuc(list: any, name: string) {
		this.importUrl = list[0];
		this.importName = name;
	}

	private async handleConfirmImport() {
		if (!this.importUrl) {
			this.$message({
				type: 'warning',
				message: '请上传发货单'
			});
			return;
		}
		try {
			this.importloading = true
			const res: any = await sellOrderDetailImport({
				ProductId: this.currentId,
				ExcelFileName: this.importName,
				ExcelFilePath: 'File/' + this.importName
			});
			this.$message({
				type: 'success',
				message: '导入成功'
			});
			this.handleCloseImport();
			this.$alert('处理中，稍后可在发货结果页下载发货结果', '导入成功', {
				confirmButtonText: '关闭',
				callback: action => {
					this.pageNo = 1;
					this.getList();
				}
			});
		} catch (err) {
			console.log(err);
			this.handleCloseImport();
			this.$message({
				type: 'error',
				message: '导入失败'
			})
		} finally {
			this.importloading = false
		}
	}

	private handleCloseImport() {
		this.showImportExel = false;
		this.showExportOrder = false;
		this.importUrl = '';
		this.exportFilterTime = '';
		this.currentId = 0;
		this.exportLoopTime = null;
		this.excelPwd = '';
	}

	private handleImport(id: number) {
		this.showImportExel = true;
		this.currentId = id;
	}

	private handleExport(id: number) {
		this.showExportOrder = true;
		this.exportFilterTime = this.filterTime.split('/')
		this.currentId = id;
	}

	private async exportFile2(e) {

		let row = await e
		let url = location.origin + '/provider/order/productSend/sentOrderDetailExport'
		url += '?Keywords=' + encodeURIComponent(this.keyword);
		url += '&ProductId=' + (row.ProductId || '');
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + (dt[0] || '');
			url += '&EndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
		}
		// console.log(url)
		// return
		window.open(url)
	}

	private async exportFile() {
		let url = location.origin + '/provider/order/sellOrderDetailExport';
		url += '?ProductIdList=' + JSON.stringify(this.currentId ? [this.currentId] : this.list.filter(v => v.ProductId).map(v => v.ProductId));
		if (this.exportFilterTime) {
			url += '&StartTime=' + (this.exportFilterTime[0] || '');
			url += '&EndTime=' + (this.exportFilterTime[1] ? nextDay(this.exportFilterTime[1], 1) : '');
		}
		// console.log(url,JSON.stringify(this.currentId?this.currentId:this.list.filter(v=>v.ProductId).map(v=>v.ProductId)))
		window.open(url);
		// if (!this.exportFilterTime && !this.exportFilterTime.length) {
		//   this.$message({
		//     type: 'warning',
		//     message: '请选择需导出的时间段'
		//   })
		//   return;
		// }
		// this.exportLoading = true;
		// try {
		//   const res: any = await logisticsExcel({
		//     logistics_export: {
		//       begin_time: parseInt(this.exportFilterTime[0] / 1000 + ''),
		//       end_time: parseInt(this.exportFilterTime[1] / 1000 + ''),
		//       product_id: this.currentId
		//     },
		//     logistics_way: 0
		//   })
		//   let curid = res.id || 0;
		//   let index = 0
		//   if (!curid) {
		//     this.$message({
		//       type: 'warning',
		//       message: '导出失败'
		//     })
		//     this.exportLoading = false;
		//     return;
		//   };
		//   this.exportLoopTime = setInterval(() => {
		//     this.exportFileReq(curid, index);
		//     index++;
		//   }, 1000);
		// } catch (err) {
		//   console.log(err)
		//   this.exportLoading = false;
		// }
	}

	private async exportFileReq(id: number, index: number) {
		try {
			const res: any = await getLogisticsExcelUrl({
				id
			});
			if (res.logistics_url) {
				downloadFile(res.logistics_url);
				clearInterval(this.exportLoopTime);
				this.exportLoopTime = null;
				this.exportLoading = false;
			} else {
				if (index >= 30) {
					this.$message({
						type: 'warning',
						message: '导出失败'
					})
					clearInterval(this.exportLoopTime);
					this.exportLoopTime = null;
					this.exportLoading = false;
					return;
				}
			}
		} catch (err) {
			console.log(err);
			this.exportLoading = false;
		}
	}

	private destroyed() {
		if (this.exportLoopTime) {
			clearInterval(this.exportLoopTime);
			this.exportLoopTime = null;
		}
	}

	private toResult() {
		console.log('toResult')
		this.$router.push({
			name: 'Order_Result'
		})
	}

}
